import { Button, Text } from 'components';
import { theme } from 'lib';
import { useState } from 'react';
import styled, { keyframes } from 'styled-components';

import { HRoss, HSeals, JGoldsmith, MAJacobs, MJackson, MVDruten } from '../Team';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const Wrapper = styled.div`
  margin-top: 32px;
  width: 100%;
  flex-direction: column;
  display: flex;
  align-items: center;

  @media (max-width: 1024px) {
    width: 100vw;
  }
`;

const ContentArea = styled.div`
  width: 1140px;
  flex-direction: column;
  display: flex;
  align-items: center;

  @media (max-width: 1024px) {
    width: inherit;
    margin: 0 13px;
  }
`;

const Header = styled(Text)`
  font-size: 72px;
  letter-spacing: -3.5px;
  align-self: start;

  @media (max-width: 1024px) {
    font-size: 48px;
    font-weight: 700;
    line-height: 37px;
    letter-spacing: -1.5px;
    width: 316px;
    margin: 0 13px;
  }
`;

const ButtonContainer = styled.div`
  width: 1050px;
  margin-top: 43px;
  margin-bottom: 20px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 0px 43px;

  button {
    margin-bottom: 22px;
  }

  @media (max-width: 1024px) {
    width: auto;
    margin: 33px 13px 20px;

    button {
      width: 124px;
      height: 30px;
      margin-bottom: 8px;

      p {
        font-size: 12px;
      }
    }
  }
`;

const TeamContainer = styled.div`
  div {
    animation: ${fadeIn} 0.3s linear;
  }
`;

const CustomMemberButton = styled(Button)`
  font-size: 18px;
  width: 30% !important;

  @media (max-width: 1024px) {
    width: 45% !important;
  }
`;

const MeetOurTeam = (props) => {
  const [shownMember, setShownMember] = useState('Houston Ross');

  function getTeamMember(name) {
    switch (name) {
      case 'Houston Ross':
        return <HRoss />;
      case 'Julius Goldsmith':
        return <JGoldsmith />;
      case 'Henry Seals':
        return <HSeals />;
      case 'Marcel Van Druten':
        return <MVDruten />;
      case 'Michael Jackson':
        return <MJackson />;
      case 'Michael A Jacobs':
        return <MAJacobs />;
      default:
    }
  }

  const TeamMemberButton = ({ name, onClick }) => {
    return (
      <CustomMemberButton
        col={shownMember === name ? theme.SECONDARY : '#E5E5E5'}
        website
        wid="220px"
        ht="54px"
        text={name}
        onClick={() => onClick(name)}
      />
    );
  };

  function handleChange(name) {
    setShownMember(name);
  }

  return (
    <Wrapper>
      <ContentArea>
        <Header stencil>MEET OUR TEAM.</Header>

        <ButtonContainer>
          <TeamMemberButton onClick={handleChange} name="Houston Ross" />
          <TeamMemberButton onClick={handleChange} name="Julius Goldsmith" />
          <TeamMemberButton onClick={handleChange} name="Marcel Van Druten" />
          <TeamMemberButton onClick={handleChange} name="Henry Seals" />
          <TeamMemberButton onClick={handleChange} name="Michael A Jacobs" />
          <TeamMemberButton onClick={handleChange} name="Michael Jackson" />
        </ButtonContainer>

        <TeamContainer transition="0.8s linear">{getTeamMember(shownMember)}</TeamContainer>
      </ContentArea>
    </Wrapper>
  );
};

export default MeetOurTeam;
